import { Currency } from '@nominex/nomiswap-sdk'

export function currencyId(currency: Currency): string {
  if (currency?.isNative) return currency.symbol?.toUpperCase()
  if (currency?.isToken) return currency.address
  throw new Error('invalid currency')
}

export function getCurrencyPrice(currency, farms) {
  return (
    farms.find((farm) => farm.token?.symbol === currency?.symbol)?.tokenPriceBusd ||
    farms.find((farm) => farm.quoteToken?.symbol === currency?.symbol)?.quoteTokenPriceBusd ||
    '0'
  )
}
